export default "__VITE_ASSET__BZa8mG5u__"